import React, { Component } from 'react';

export default class extends Component {
    render() {
        return (
            <div className="header">
                <div className="contains">
                    <h1 className="logo">
                        {this.props.logoImgUrl &&
                            <a href={this.props.logoUrl} target="_blank">
                                <img src={this.props.logoImgUrl} alt={this.props.tenantName} alt="로고"/>
                            </a>
                        }
                    </h1>
                    {/*<a href="#" className="btn-my">MY</a>*/}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Header.js